import type { Candidate, Corrections, Session } from '../fsm/machine';

// Il commit in sospeso (ARCHITETTURA §7.4, ADR-011): UN record in localStorage, scritto prima della chiamata e
// cancellato SOLO dopo il 201/200. Un ricarico a metà commit riprende da qui; la sessione server vive 30 minuti.

const KEY = 'dim.pending';

export interface PendingCommit {
  session: Session;
  candidate: Candidate;
  corrections: Corrections | null;
  capturedAtUtc: string | null;
  savedAtUtc: string;
}

export const pending = {
  save(p: Omit<PendingCommit, 'savedAtUtc'>): void {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...p, savedAtUtc: new Date().toISOString() } satisfies PendingCommit));
    } catch {
      // Spazio esaurito o storage negato: il commit procede lo stesso, solo il ricarico non riprenderà.
    }
  },
  load(): PendingCommit | null {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const p = JSON.parse(raw) as PendingCommit;
      // Oltre la vita della sessione di cattura il record è inutile: il server risponderebbe 410.
      if (Date.parse(p.candidate.expiresAtUtc) < Date.now()) {
        localStorage.removeItem(KEY);
        return null;
      }
      return p;
    } catch {
      return null;
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(KEY);
    } catch {
      // niente da fare
    }
  },
};
